import axios from "axios";
import config from "../../common/config";
import { errorMsg } from "../simpleMessageAlert";
import Qs from "qs";
import { Routes } from "../../common/Routes";
import { AlertMessage } from "../../common/data/AlertMsg";
import { logout } from "../authentication/oktaConfig";
import { getErrFromResponse, HTTP_ERR } from "src/common/errors";

function getBaseUrl() {
  return config.backendUrl;
}

const backendAxios = axios.create({
  baseURL: getBaseUrl(),
  timeout: 30000,
  paramsSerializer: function (params) {
    return Qs.stringify(params, { arrayFormat: "brackets" });
  },
});

const showErrorMessages = ({ errors }) => {
  errors.forEach(({ errorMessage }) => {
    errorMsg(`Error : ${errorMessage}`);
  });
};

const callAPI = async (axiosInstance, method, url, data, params, handleError = true,config={}) => {
  try {
    const accessToken = window.getOktaAccessToken();
    const result = await axiosInstance({
      method,
      url,
      data,
      params,
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json",
        "X-Referer": window.location.origin,
      },
      ...config
    });
    return result.data.data || result.data;
  } catch (err) {
    if (handleError) {
      const { errData, customErrCode } = getErrFromResponse(err);
      switch (customErrCode) {
        case HTTP_ERR.AUTH_ERROR:
          showErrorMessages(errData);
          await logout();
          break;
        case HTTP_ERR.FORBIDDEN_ERROR:
          onForbiddenError(method, url);
          break;
        case HTTP_ERR.CLIENT_ERROR:
          onClientError(method, url, errData);
          break;
        case HTTP_ERR.SERVER_ERROR:
          errorMsg(AlertMessage.axiosErrors.serverError);
          break;
        case HTTP_ERR.TIMEOUT_ERROR:
          errorMsg(AlertMessage.axiosErrors.timeoutError);
          break;
        case HTTP_ERR.CONNECTION_REFUSED:
          if (config.cancelToken == null) {
            errorMsg(AlertMessage.axiosErrors.connectionRefused)
          };
          break;
        default:
      }
    }
    throw err;
  }
};

const onForbiddenError = (method, url) => {
  if (method === "patch" && url.startsWith("/bff/user-groups/") && url.endsWith("/membership")) {
    return;
  }
  window.location = Routes.Forbidden.path;
};

const onClientError = (method, url, errData) => {
  const checkIfRefresh = (errData) => {
    return !!errData?.errors?.find(
      (error) => ["REVIEW_CLOSED", "REVIEW_OPEN"].indexOf(error.errorKey) !== -1
    );
  };

  if (method === "patch" && url.startsWith("/bff/user-groups/") && url.endsWith("/membership")) {
    return;
  }

  if (errData?.errors?.some((error) => error.errorKey === "USER_GROUP_NOT_FOUND") && url.includes("user-group-detail")) {
    return
  }

  showErrorMessages(errData);
  if (checkIfRefresh(errData)) {
    setTimeout(() => window.location.reload(), 2500);
  }
};

export const callBackendApi = async (method, url, data, params, handleError,config) =>
  callAPI(backendAxios, method, url, data, params, handleError,config);

export default backendAxios;
